module.exports = __webpack_public_path__ + "static/media/cardEight.a9c0576e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Images/rowSix/cardEight.jpg
// module id = 90
// module chunks = 0